import React from 'react';
import { Navigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { useAuth } from '../context/AuthContext';

// Guards the /admin/* routes. The portal is web-only and admin-only:
// native (Capacitor) builds and non-admin users are redirected to /books.
export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  const isWeb = !Capacitor.isNativePlatform();
  if (user && user.is_admin && isWeb) {
    return children;
  }
  return <Navigate to="/books" replace />;
}
